import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from '@edx/frontend-platform/i18n';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

import { Toast } from '@openedx/paragon';
// import FooterSlot from '@openedx/frontend-slot-footer';
// import HeaderSlot from '../plugin-slots/HeaderSlot';
import PageLoading from '../generic/PageLoading';
import { getAccessDeniedRedirectUrl } from '../shared/access';
import { useModel } from '../generic/model-store';

import genericMessages from '../generic/messages';
import messages from './messages';
import LoadedTabPage from './LoadedTabPage';
import { setCallToActionToast } from '../course-home/data/slice';
import LaunchCourseHomeTourButton from '../product-tours/newUserCourseHomeTour/LaunchCourseHomeTourButton';
import Header from '../layouts/Header';
import Footer from '../layouts/Footer';

import InstructorToolbar from '../instructor-toolbar';
import { Alert, ALERT_TYPES } from '../generic/user-messages';

const TabPage = ({ intl, ...props }) => {
  const {
    activeTabSlug,
    courseId,
    courseStatus,
    metadataModel,
    unitId,
  } = props;
  const {
    toastBodyLink,
    toastBodyText,
    toastHeader,
  } = useSelector(state => state.courseHome);
  const dispatch = useDispatch();
  const [masqueradeErrorMessages, showMasqueradeErrors] = useState(null);
  const [isSpecificStudent,setIsSpecificStudent] = useState(false)

  const {
    courseAccess,
    number,
    org,
    start,
    title,
    originalUserIsStaff,
    tabs,
  } = useModel('courseHomeMeta', courseId);

  const [pageHeight, setPageHeight] = useState(0);
  const handleResize = () => {
    const windowHeight = window.innerHeight;
    const footer = document.querySelector("footer");
    const header = document.querySelector("header");
    const main = document.querySelector("main");
    if (footer && header && main) {
      const footerHeight = footer.offsetHeight;
      const headerHeight = header.offsetHeight;
      const mainHeight = main.offsetHeight;
      if (mainHeight < windowHeight) {
        setPageHeight(windowHeight - footerHeight - headerHeight);
      } else {
        setPageHeight(0);
      }
    }
  };

  useEffect(() => {
    let isListenerAdded = false;
    const resizeHandler = () => {
      const mainElement = document.querySelector("main");
      if (mainElement) {
        handleResize();
        if (!isListenerAdded){
          window.addEventListener("resize", handleResize);
          isListenerAdded = true;
        }
      } else {
        const intervalId = setInterval(() => {
          const main = document.querySelector("main");
          if (main) {
            handleResize();
            clearInterval(intervalId);
            if (!isListenerAdded){
              window.addEventListener("resize", handleResize);
              isListenerAdded = true;
            }
          }
        }, 500);
      }
    };
    resizeHandler();
    window.addEventListener("resize", resizeHandler);
    return () => {
      window.removeEventListener("resize", resizeHandler);
      window.addEventListener("resize", handleResize);
    }
  }, []);

  if (courseStatus === 'denied') {
    const redirectUrl = getAccessDeniedRedirectUrl(courseId, activeTabSlug, courseAccess, start);
    if (redirectUrl) {
      return (<Navigate to={redirectUrl} replace />);
    }
  }

  return (
    <>
      {['loaded', 'denied'].includes(courseStatus) && (
        <>
          <Toast
            action={toastBodyText ? {
              label: toastBodyText,
              href: toastBodyLink,
            } : null}
            closeLabel={intl.formatMessage(genericMessages.close)}
            onClose={() => dispatch(setCallToActionToast({ header: '', link: null, link_text: null }))}
            show={!!(toastHeader)}
          >
            {toastHeader}
          </Toast>
          {metadataModel === 'courseHomeMeta' && (<LaunchCourseHomeTourButton srOnly />)}
        </>
      )}

      {/* <HeaderSlot courseOrg={org} courseNumber={number} courseTitle={title} /> */}
      <Header isSpecificStudent={isSpecificStudent}>
        {originalUserIsStaff && (
          <InstructorToolbar
            courseId={courseId}
            unitId={unitId}
            tab={activeTabSlug}
            showMasqueradeErrors={showMasqueradeErrors}
            setIsSpecificStudent={setIsSpecificStudent}
          />
        )}
      </Header>

      {masqueradeErrorMessages && (
        <div className="container-xl mt-3">
          <Alert type={ALERT_TYPES.ERROR} dismissible={false}>
            {masqueradeErrorMessages}
          </Alert>
        </div>
      )}

      {courseStatus === 'loading' && (
        <PageLoading srMessage={intl.formatMessage(messages.loading)} />
      )}

      {['loaded', 'denied'].includes(courseStatus) && (
        <LoadedTabPage {...props} pageHeight={pageHeight} />
      )}

      {/* courseStatus 'failed' and any other unexpected course status. */}
      {(!['loading', 'loaded', 'denied'].includes(courseStatus)) && (
        <p className="text-center py-5 mx-auto" style={{ maxWidth: '30em' }}>
          {intl.formatMessage(messages.failure)}
        </p>
      )}
      <Footer />
    </>
  );
};

TabPage.defaultProps = {
  courseId: null,
  unitId: null,
};

TabPage.propTypes = {
  activeTabSlug: PropTypes.string.isRequired,
  intl: intlShape.isRequired,
  courseId: PropTypes.string,
  courseStatus: PropTypes.string.isRequired,
  metadataModel: PropTypes.string.isRequired,
  unitId: PropTypes.string,
};

export default injectIntl(TabPage);
